module.exports = __webpack_public_path__ + "assets/img/blessing.12b4f240.png";